import { makeStyles } from '@material-ui/styles';
import { Theme } from '@bizzabo/design-system';

const DrawerDivider: React.FC = () => {
    const classes = useStyles();
    return <div className={classes.divider} />;
};

export const useStyles = makeStyles<Theme>(
    theme => ({
        divider: {
            height: 1,
            backgroundColor: theme.customization.background.C30,
            minWidth: '100%',
        },
    }),
    { classNamePrefix: 'drawer-divider' }
);

export default DrawerDivider;
